import React, { Component } from 'react'
import { withRouter, Redirect, Route, Switch } from 'react-router-dom'
import URLSearchParams from 'url-search-params'
import Cookies from 'js-cookie'
import API from '../../../api/auth'
import QuickStartPage from '../../pages/QuickStart'
import OAuthLandingPage from '../../pages/OAuthLanding'
import OAuthLoginPage from '../../pages/OAuthLogin'
import { setSnippets } from 'utils/snippets'

import './style.css'

class OAuth extends Component {

  constructor(props) {
    super(props)
    const queryParams = new URLSearchParams(this.props.location.search)

    this.state = {
      clientId: queryParams.get('client_id'),
      redirectURI: queryParams.get('redirect_uri'),
      oauthState: queryParams.get('state') || null,
      OAuthCode: null,
      appInfo: {
        name: '',
        description: '',
        logo: ''
      }
    }

    this.setCode = this.setCode.bind(this)
    this.redirectWithCode = this.redirectWithCode.bind(this)
  }

  componentDidMount() {
    const { clientId, redirectURI } = this.state
    const token = Cookies.get('DrifttAuth') || null

    this.trackUsage()
    
    if (!clientId || !redirectURI) {
      console.warn('missing params')
    }

    const updateState = (response) => {
      if (response.status === 200){
        this.setState({ appInfo: response.data })
      }
    }
    API.fetchOAuthAppInfo(clientId, updateState)

    token && API.fetchOAuthCode(
      token, this.state.clientId, 
      this.state.redirectURI, 
      resp => this.setCode(resp.data.code)
    )
  }

  trackUsage = () => {
    setSnippets()
    window.analytics.page('OAuth Connect', {
      clientId: this.state.clientId,
      version: 'old',
    })
  }

  redirectWithCode() {
    let queryString = `?code=${this.props.location.state.code}`
    if (this.state.oauthState) queryString += `&state=${this.state.oauthState}`
    window.location.replace(`${this.state.redirectURI}${queryString}`)
  }

  setCode(code) {
    this.setState({OAuthCode: code})
  }

  render() {
    const { name } = this.state.appInfo
    const propsForChild = {...this.state, setCode: this.setCode, redirectWithCode: this.redirectWithCode}

    return (
      <div className="drift-oauth-connect">
        <h1>Connect Drift with { name }</h1>

        {this.state.OAuthCode && <Redirect to={{pathname: '/authorize/confirmation', search: location.search, state: {code: this.state.OAuthCode} }} />}
        
        <Switch>
          <Route exact path="/authorize" render={ () => <QuickStartPage {...propsForChild} /> }  />
          <Route path="/authorize/confirmation" render={ () => <OAuthLandingPage {...propsForChild} /> }  />
          <Route path="/authorize/login" render={ () => <OAuthLoginPage {...propsForChild} /> } />
          <Route path="/authorize/quick-start" render={ () => <QuickStartPage {...propsForChild} /> }  />
        </Switch>

      </div>
    )
  }
}

const OAuthLayout = withRouter(OAuth)

export default OAuthLayout



// WEBPACK FOOTER //
// ./src/components/layouts/OAuthConnect/index.js